import React, { useState } from 'react'
import colors from '../../utils/colors'
import { displayErrorMsg } from '../../utils/displayErrorMsg'
import { eye, openedEye } from '../../assets'

interface IProps {
    handleChange: (val: string) => void
    property: string
    value: string
    submitting?: boolean
    title: string
    placeholder: string
    isPassword?: boolean
    labelStyles?: string
    inputStyles?: string
}
const Input = ({ handleChange, property, value, submitting = false, title, isPassword = false, placeholder, labelStyles, inputStyles }: IProps) => {
    const [see, setSee] = useState(false)
    return (
        <div className=' w-full'>
            <p className={`text-sm mb-2 ${labelStyles}`}>{title}</p>
            <div className='w-full relative'>
                <input
                    onChange={(e) => handleChange(e.target.value)}
                    style={{ border: '1px solid', borderColor: colors.grey, color: colors.placeholderColor }}
                    placeholder={placeholder}
                    name={property}
                    type={(isPassword && !see) ? 'password' : 'text'}
                    className={`placeholder:text-[#606060] text-xs rounded-md w-full p-2 outline-none ${inputStyles}`}
                />
                {
                    isPassword &&
                    <div className='h-full absolute flex items-center right-3 top-0 cursor-pointer'>
                        <img
                            src={see ? openedEye : eye}
                            className='h-[20px]'
                            onClick={() => setSee(!see)}
                        />
                    </div>
                }
            </div>
            {displayErrorMsg(`${title} cannot be empty`, value, submitting)}
        </div>
    )
}

export default Input